import { useGetIdentity, type Identifier } from "ra-core";
import { useGetSalesName } from "../sales/useGetSalesName";
import { actorLabel } from "./activityModel";

export function ActivityAuthor({ id }: { id?: Identifier | null }) {
  const { identity } = useGetIdentity();
  const name = useGetSalesName(id);
  return <>{actorLabel(id, name, identity)}</>;
}
